import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { CALENDAR_Z_INDICES } from '../../constants';
import { useCalendarGridStore } from '../../store/calendar-grid.store';
import { timeToRowNumber } from '../../utils';

const BADGE_HEIGHT = 20;

interface Props {
  gridColumn: string;
  currentTime: string; // HH:mm format, e.g. "14:30"
}

export const CurrentTimeIndicator = ({ gridColumn, currentTime }: Props) => {
  const timeIndicatorLines = useCalendarGridStore((s) => s.timeIndicatorLines);
  if (timeIndicatorLines === 'none') return null;

  // TODO: update time every minute
  const gridRow = `${timeToRowNumber(currentTime)}/ span 1`;

  return (
    <>
      <div data-current-line css={lineContainerStyle} style={{ gridColumn, gridRow }} />
      <div data-current-line-badge css={badgeContainerStyle} style={{ gridColumn, gridRow }}>
        <div css={badgeStyle}>
          <Text color='white' textAlign='center' size='small'>
            {currentTime}
          </Text>
        </div>
      </div>
    </>
  );
};

const lineContainerStyle = css({
  position: 'relative',
  zIndex: CALENDAR_Z_INDICES.currentTimeIndicatorLine,
  pointerEvents: 'none',
  border: `1px solid ${theme.colors.primary50}`,
  boxShadow: theme.shadows.light,
});

const badgeContainerStyle = css({
  zIndex: CALENDAR_Z_INDICES.currentTimeIndicatorBadge,
  pointerEvents: 'none',
});

const badgeStyle = css({
  '--badge-width': 'var(--group-separator-width)',
  backgroundColor: theme.colors.primary50,
  borderRadius: theme.borderRadius.medium,
  position: 'sticky',
  left: `calc(var(--time-column-width) - var(--badge-width))`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'var(--badge-width)',
  height: BADGE_HEIGHT,
  marginTop: `calc(-${BADGE_HEIGHT / 2}px)`,
  marginLeft: `calc(-1 * var(--badge-width))`,
});
